import { computed, } from 'vue'
import { genHeadOverrides, } from '@/assets/js/src/layout/meta'
import { useMessagesLoaded, } from '@/assets/js/src/modules/lang/_composables/useMessagesLoaded'
import { useTranslation, } from '@/assets/js/src/util/composables'
import { useRoute, } from 'vue-router'
import { getActivePinia, } from 'pinia'
import { useHead, } from '@unhead/vue'

export const useListHeadInfo = ({ provider, }) => {
    const { messagesLoaded, } = useMessagesLoaded([ 'resource', ])
    const { t, } = useTranslation()
    const currentRoute = useRoute()
    const activePinia = getActivePinia()

    const title = computed(() => {
        return messagesLoaded.value
            ? t(`async.resource.${provider.value}.list.meta_title`)
            : ''
    })

    const description = computed(() => {
        return messagesLoaded.value
            ? t(`async.resource.${provider.value}.list.meta_description`)
            : ''
    })

    const canonical = computed(() => {
        return `${activePinia.state.value.baseUrl}/${currentRoute.params.provider}`
    })

    useHead(genHeadOverrides({ title, description, canonical, }))
}
